import React, { useState, useContext } from 'react'
import { Outlet } from 'react-router-dom'
import { experimentalStyled } from '@material-ui/core'
import MainNavbar from './MainNavbar'
import MainSidebar from './MainSidebar'

// contexts
import { ShoppingCartContext } from '../contexts/ShoppingCart'


const { innerWidth: windowWidth } = window
const MainLayoutRoot = experimentalStyled('div')(({ theme }) => ({
   backgroundColor: theme.palette.background.paper,
   display: 'flex',
   height: '100%',
   overflow: 'hidden',
   width: '100%',
   
}))

const MainLayoutWrapper = experimentalStyled('div')(({ theme }) => {
   const { searchC, hoseSizesC, dashSizesC, pressuresC, sizesC, drawerOpen } = useContext(ShoppingCartContext)

   return {
      display: 'flex',
      flex: '1 1 auto',
      overflow: 'hidden',
      paddingTop: 64,
      [theme.breakpoints.up('lg')]: {
         paddingLeft:
            (searchC && (hoseSizesC.length > 0 || dashSizesC.length > 0)) ||
               (searchC && (pressuresC.length > 0 || sizesC.length > 0)) ||drawerOpen
               ? 256
               : 0
      }
   }
})

const MainLayoutContainer = experimentalStyled('div')({
   display: 'flex',
   flex: '1 1 auto',
   overflow: 'hidden', 
})

const MainLayoutContent = experimentalStyled('div')({
   flex: '1 1 auto',
   height: '100%',
   overflow: 'auto',
})

const MainLayoutContentMobile = experimentalStyled('div')({
   flex: '1 1 auto',
   height: '100%',
   overflow: 'auto',
   paddingTop: 35
})

const MainLayout = () => {
   const [isMobileNavOpen, setMobileNavOpen] = useState(false)
   const { drawerOpen,setDrawerOpen } = useContext(ShoppingCartContext)

   return (
      <MainLayoutRoot>
         <MainNavbar onMobileNavOpen={() => { setMobileNavOpen(!isMobileNavOpen); setDrawerOpen(!drawerOpen) }} />
         <MainSidebar onMobileClose={() => { setMobileNavOpen(!isMobileNavOpen); setDrawerOpen(!drawerOpen) }} openMobile={isMobileNavOpen} />
         <MainLayoutWrapper>
            {windowWidth > 425 &&
               <MainLayoutContainer>
                  <MainLayoutContent>
                     <Outlet />
                  </MainLayoutContent>
               </MainLayoutContainer>
            }
            {windowWidth <= 425 &&
               <MainLayoutContainer>
                  <MainLayoutContentMobile>
                     <Outlet />
                  </MainLayoutContentMobile>
               </MainLayoutContainer>
            }
         </MainLayoutWrapper>
      </MainLayoutRoot>
   )
}

export default MainLayout
